<template>
    <div class="card-responsible-contacts" aria-live="polite">
        <p v-if="loading && !people.length && !error" role="status"><b-spinner small /> Загружаем ответственных…</p>
        <div v-else-if="error" role="alert">
            <p>{{ error }}</p>
            <b-button size="sm" variant="outline-danger" :disabled="loading" @click="refresh">Повторить загрузку</b-button>
        </div>
        <template v-else-if="people.length">
            <strong>{{ reserveReturn ? 'Чтобы вернуть сотрудника из резерва, обратитесь к:' : 'Чтобы создать карточку сотрудника, обратитесь к:' }}</strong>
            <ul role="list">
                <li v-for="(person, index) in people" :key="person.user_id">
                    <span v-if="index" class="card-responsible-contacts__alternative">либо </span>
                    <EmployeeLink :user-id="person.user_id" :fallback="person.name" compact />
                    <span v-if="person.labels.length"> · {{ person.labels.join(' · ') }}</span>
                </li>
            </ul>
        </template>
        <p v-else-if="configured === false"><template v-if="!reserveReturn">Если ФИО указано верно, </template>
            <b>обратитесь в кадровую службу либо к куратору объекта</b> — {{ reserveReturn ? 'сотрудника нужно вернуть из резерва с указанием трудового периода.' : 'сотруднику нужно создать карточку.' }}</p>
        <p v-else>Ответственные сейчас недоступны.
            Обратитесь к администратору Аргуса.</p>
    </div>
</template>

<script>
import api from '@/utils/api';
import EmployeeLink from '@/components/EmployeeLink.vue';

export default {
    name: 'TimesheetEmployeeCardContacts',
    components: {EmployeeLink},
    props: {timesheetId: {type: [Number, String], required: true}, reserveReturn: Boolean},
    data() { return {people: [], configured: null, loading: false, error: '', requestVersion: 0, timer: null}; },
    watch: {
        timesheetId: {immediate: true, handler() {
            this.people = [];
            this.configured = null;
            this.refresh();
        }}
    },
    beforeDestroy() {
        clearTimeout(this.timer);
        this.requestVersion += 1;
    },
    methods: {
        async refresh() {
            clearTimeout(this.timer);
            const version = ++this.requestVersion;
            this.loading = true;
            try {
                const response = await api.get(`/api/timesheets/${this.timesheetId}/employee-card-responsibles`, {ignoreModal: true});
                if (version === this.requestVersion) {
                    this.people = response.data.people;
                    this.configured = response.data.configured !== false;
                    this.error = '';
                }
            } catch (error) {
                if (version === this.requestVersion) {
                    this.people = [];
                    this.error = 'Не удалось загрузить ответственных. Повторите загрузку контактов.';
                }
            } finally {
                if (version === this.requestVersion) {
                    this.loading = false;
                    this.timer = setTimeout(() => this.refresh(), 10000);
                }
            }
        }
    }
};
</script>

<style scoped>
.card-responsible-contacts { margin-top: .75rem; overflow-wrap: anywhere; }
.card-responsible-contacts ul { margin: .5rem 0 0; padding-left: 0; list-style: none; max-height: 25vh; overflow-y: auto; }
.card-responsible-contacts li { margin-bottom: .5rem; }
.card-responsible-contacts__alternative { font-weight: 600; }
.card-responsible-contacts p { margin-bottom: .5rem; }
</style>
